const tableTitleCompany = {
  title: 'Third Party Companies',
  placeholder: 'Search',
  Typography: 'No results found'
};

export default tableTitleCompany;
